import { connect } from "react-redux";
import {default as HomeV} from "./Home";
import {default as DashboardView} from "./Dashboard";
import {default as ReviewUserV} from "./ReviewUser";
import {default as ReviewUserFormV} from "./ReviewUserForm";
import {default as ReviewUserChartView} from "./ReviewUserChart";
import {default as TagsV} from "./Tags";
import {default as TagsChartV} from "./TagsChart";
import {default as TagsSearchFormV} from "./TagSearchForm";
import {actions} from "./logic/actions";
import {STATUS_COLORS} from "core/dataConstants";
import {default as FilmR} from "./FilmReleaseStatistics";

export default HomeV;
export const Dashboard = DashboardView;

export const ReviewUserForm = connect(
    ({statistics}) => ({
        form:statistics.reviewUserForm
    }),
    (dispatch) => ({
        runSearch:() => dispatch(actions.RUN_REVIEW_USER_QUERY.send()),
        onChangeForm : (payload) => dispatch(actions.ON_CHANGE_REVIEW_FORM.call(payload)),
        clearForm: () => dispatch(actions.ON_CLEAR_REVIEW_FORM.call())
    })
)(ReviewUserFormV);

export const ReviewUserChart = connect(
    ({statistics, globalApp}) => ({
        statuses :statistics.statusLastSearch,
        data: statistics.reviewUserData,
        globalStatuses: globalApp.reviewStatusTypes,
        reviewUserQueryStatus: statistics.reviewUserQueryStatus
    })
)(ReviewUserChartView);
export const ReviewUser = ReviewUserV;

export const Tags = TagsV;
export const TagsChart = connect(  ({statistics}) => ({
    tags :statistics.tags,
    data: statistics.tagsData,
    tagsQueryStatus:statistics.tagsQueryStatus
}))(TagsChartV);

export const TagsSearchForm = connect(
    ({statistics}) => ({
        form:statistics.tagsForm
    }),
    (dispatch) => ({
        runSearch:() => dispatch(actions.RUN_TAGS_QUERY.send()),
        onChangeForm : (payload) => dispatch(actions.ON_CHANGE_TAGS_FORM.call(payload)),
        clearForm: () => dispatch(actions.ON_CLEAR_TAGS_FORM.call())
    })
)(TagsSearchFormV);


export const FilmReleaseStatistics = FilmR;




export function getGroupStatusByStatus(status){
    const id = status.value ? status.value : status.id;
    if(id === 1) {
        return {};
    }
    if(id === 2) {
        return { stackId: "approved", fill:STATUS_COLORS.APPROVED.color };
    }
    if(id === 3) {
        return { stackId: "approved", fill:STATUS_COLORS.APPROVED_RESTIRCTIONS.color };
    }
    if(id === 4) {
        return { stackId: "pending", fill:STATUS_COLORS.PENDING_APPROVAL.color };
    }
    if(id === 5) {
        return { stackId: "pending", fill: STATUS_COLORS.PENDING_APPROVAL_RESTIRCTIONS.color };
    }
    if(id === 6) {
        return { stackId: "disapproved", fill: STATUS_COLORS.DISAPPROVED.color };
    }
}
